module.exports = __webpack_public_path__ + "static/media/3-3.d72078f2.webp";